// import { createStore, applyMiddleware } from 'redux';
import { configureStore } from "@reduxjs/toolkit";
// import thunk from 'redux-thunk';
import rootReducer from './reducers';

export default configureStore({
  reducer: rootReducer
})
// export default createStore(rootReducer, applyMiddleware(thunk));
